import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/construction-software/ready-cta.webp";

function Customconstruction() {
  return (
    <section
      className="streamline_cloud p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundPosition: "center top",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={8} lg={7} xl={6} xxl={6}>
            <h2>
              Ready to Develop Your <span>Custom Construction</span> Software?
            </h2>
            <p>
              Fill out a short form to specify your unique requirements and let
              our experts create a tailored construction software solution for
              your business.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Get Started Today
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Customconstruction;
